<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <SmallSquare content='扫码模板是扫码活动的前端呈现页，是消费者扫码参与活动的交互载体，扫码模板的趣味性、体验感将直接影响消费者的扫码体验；' :padding='false'></SmallSquare>
      <!-- <div class="mb25 m-t-25 s_flex_bian_c">
        <div>
          <span class='mr15'>
            <a-button type="primary" @click="createTemplate">
              <PlusOutlined />
              添加模板
            </a-button>
          </span>
        </div>
      </div> -->
      <div class="s_flex_ali m-t-20 m-b-20">
        是否进入溯源页：
        <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="is_open_sy" @change='setConfig' />
        <a-tooltip placement='right'>
          <template #title>控制开启智能营销活动时消费者扫码进入的扫码模板路径，“开启”表示需先进入溯源模板，“关闭”表示消费者扫码后直接进入扫码活动模板。</template>
          <QuestionCircleOutlined class="s_c376 m-l-10 fz-16" />
        </a-tooltip>
      </div>
      <a-spin :spinning="loading">
        <a-tabs default-active-key="1" @change="callback" v-model:activeKey="activeKey">
          <a-tab-pane key="1" tab="模板商城">
            <!-- <a-form ref='form' :model='search' class="m-t-10" :style="{'marginBottom':'20px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
              <a-form-item label="模板名称" name='time'>
                <a-input placeholder="请输入模板名称进行搜索" style="width:250px" v-model:value="search.keyword" />
              </a-form-item>
              <a-form-item>
                <a-button type="primary" htmlType='submit' class='m-r-10' @click="pageSearchChange">搜索</a-button>
              </a-form-item>
            </a-form> -->
          </a-tab-pane>
          <a-tab-pane key="2" tab="我的模板">
            <a-form ref='form' :model='search' class="m-t-10" :style="{'marginBottom':'20px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
              <a-form-item label="创建时间" name='time'>
                <a-range-picker valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD  ' @change="changTime" />
              </a-form-item>
              <a-form-item label="模板类型" name='type'>
                <a-select :style="{width:'140px'}" placeholder="请选择模板类型" v-model:value="search.type">
                  <a-select-option value="">全部</a-select-option>
                  <a-select-option :value="v.type_id" v-for="v in typeList" :key="v.type_id">{{v.type_name}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="模板名称" name='time'>
                <a-input placeholder="请输入模板名称进行搜索" style="width:250px" v-model:value="search.keyword" />
              </a-form-item>
              <a-form-item>
                <a-button type="primary" htmlType='submit' class='m-r-10' @click="pageSearchChange">搜索</a-button>
              </a-form-item>
            </a-form>
          </a-tab-pane>
           <a-tab-pane key="3" tab="定制模板" v-if="is_customized">
       
          </a-tab-pane>
        </a-tabs>
        <a-table
          v-if="activeKey === '2'"
          :pagination="false"
          bordered
          rowKey="id"
          :columns="myTemplateColumns"
          :data-source="list"
          :scroll="{ x: 1100 }"
        >
          <template v-slot:templateType="{ record }">
            {{ getTemplateTypeName(record) }}
          </template>
          <template v-slot:useStatus="{ record }">
            <a-tag :color="record.is_use ? 'green' : 'default'">
              {{ record.is_use ? '已使用' : '未使用' }}
            </a-tag>
          </template>
          <template v-slot:defaultStatus="{ record }">
            <a-tag v-if="record.is_default" color="blue">默认模板</a-tag>
            <span v-else>-</span>
          </template>
          <template v-slot:templateAction="{ record }">
            <a
              href="javascript:;"
              class="m-r-15"
              @click="$router.push({path:'/qrcode/template/create',query:{type:record.type,id:record.id,is_default:activeKey,mark:record.mark}})"
            >
              编辑
            </a>
            <a href="javascript:;" v-if="!record.is_default" @click="del(record.id)">删除</a>
          </template>
        </a-table>
        <a-row v-else :gutter="[20,16]">
          <a-col :span="4" v-for="v in list" :key="v.id">
            <a-card style="overflow:hidden;">
              <!-- ;padding: 10px;border: 1px solid #eee -->
              <div style="width:100%;height:300px;position:relative;padding-top:8px"  class="tempalteImg" 
               :class="{'newTemplateImg':v.template_thumb&&v.template_thumb.indexOf('data:image')!=-1}">
                <!-- <img src="@/assets/images/scan/mini_bar.png" alt="" class="bar" v-if="v.type==2"> -->
              <!-- <div class="templateTags">{{v.type==1?'普通模板':'云店模板':v.type==3?'溯源模板':'大转盘模板'}}</div> -->
                <div class="mask">
                  <p>id: {{v.id}}</p>
                  <p v-if="activeKey!=1">创建时间: {{v.created_time}}</p>
                  <p class="s_omit">备注：{{v.remarks}}</p>
                </div>
                <img :src="v.template_thumb" alt="" v-if="v.template_thumb&&v.template_thumb.indexOf('data:image')!=-1">
                 <img :src="oss.picdomain+v.template_thumb+'?date='+new Date()" alt="" v-else>
              </div>
              <p class="mt10">{{v.name}} <!--()--> </p>
              <div class="s_cd41 mt10 m-b-10 s_flex_bian_c">  <div><span class="label">使用状态：</span> {{v.is_use?'已使用':'未使用'}} <span style="color:#000">{{v.is_default&&activeKey==2?'默认':''}}</span></div> </div>
              <div style="justify-content: flex-end;">
            
              </div>
              <div :class="activeKey!=1?'s_flex_bian_c':'actions'">
                <div class="s_flex_bian_c">
                  <a-button @click="$router.push({path:'/qrcode/template/create',query:{type:v.type,id:v.id,is_default:activeKey,mark:v.mark}})" class='m-r-5' >{{activeKey==2?'编辑':activeKey==3?'定制模板':"创建模板"}}</a-button>
                  <a-button  @click="del(v.id)"  v-if="!v.is_default&&activeKey==2">删除</a-button>
                </div>
              </div>
            </a-card>
          </a-col>
        </a-row>
      </a-spin>
      <div class="m-t-30 m-b-30 s_text_c">
        <a-empty v-if="activeKey !== '2' && !loading && !list.length" />
      </div>
      <a-pagination :style="{marginTop:'10px',textAlign:'right'}" show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" :show-total="total => `总数: ${total} `"  />
    </a-card>
  </a-layout>
  <a-modal :keyboard="false" v-model:visible="templateVisible" centered style="width:700px" :width='1000' :footer="null">
    <ul class='panel'>
      <li>
        <router-link tag="li" to="/qrcode/template/create?type=1">
          <div class="panelContent ">
            <img src="@/assets/images/code/activity_template.png" alt="" />
            <div class='name'>普通模板</div>
          </div>
        </router-link>
      </li>
      <li>
        <router-link tag="li" to="/qrcode/template/create?type=3">
          <div class="panelContent ">
            <img src="@/assets/images/code/activity_template.png" alt="" />
            <div class='name'>溯源模板</div>
          </div>
        </router-link>
      </li>
      <li>
        <router-link tag="li" to="/qrcode/template/create?type=2">
          <div class="panelContent ">
            <img src="@/assets/images/code/store_template.png" alt="" />
            <div class='name'>云店模板</div>
          </div>
        </router-link>
      </li>
    </ul>
  </a-modal>
</template>
<script>
import { onMounted, ref } from "vue";
import {
  getTemplates,
  delTemplates,
  getSysTemplates,
  setDefault,
  getCustomizedTemplates,
  is_have_customized,
  getTemplatesTypeList,
  getAdvertisement, updateAdvertisement
} from "@/api/qrcodeActivitys";
import { iscode } from "@/utils/app";
import store from '@/store'
import { Modal } from "ant-design-vue";
import {QuestionCircleOutlined} from "@ant-design/icons-vue";
const def = {
  page: 1,
  limit: 6,
  type: "",
  keyword: "",
  start_time: "",
  end_time: "",
};
const myTemplateColumns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    width: 90,
  },
  {
    title: "模板名称",
    dataIndex: "name",
    key: "name",
    width: 220,
    ellipsis: true,
  },
  {
    title: "模板类型",
    dataIndex: "type",
    key: "type",
    width: 140,
    slots: { customRender: "templateType" },
  },
  {
    title: "使用状态",
    dataIndex: "is_use",
    key: "is_use",
    width: 110,
    slots: { customRender: "useStatus" },
  },
  {
    title: "默认状态",
    dataIndex: "is_default",
    key: "is_default",
    width: 110,
    slots: { customRender: "defaultStatus" },
  },
  {
    title: "创建时间",
    dataIndex: "created_time",
    key: "created_time",
    width: 180,
  },
  {
    title: "备注",
    dataIndex: "remarks",
    key: "remarks",
    ellipsis: true,
  },
  {
    title: "操作",
    key: "action",
    width: 130,
    fixed: "right",
    slots: { customRender: "templateAction" },
  },
];
export default {
  components:{QuestionCircleOutlined},
  setup() {
    // 模板声明 type 1 普通扫码模板 2 云店模板 3 溯源模板 4.大转盘（普通）
    const activeKey = ref("1");
    const oss = store.state.user.info;
    const search = ref({...def});
    const list = ref([]);
    const total = ref(0);
    const changTime = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
    };
    const loading = ref(false);
    const initData = async () => {
      list.value=[];
      loading.value = true;
      let result;
      if (activeKey.value == 1) {
        result = await getSysTemplates(search.value)
          .then((res) => res.data)
          .catch((error) => error);
      } else if(activeKey.value==2) {
        result = await getTemplates(search.value)
          .then((res) => res.data)
          .catch((error) => error);
      }else{
       result = await getCustomizedTemplates(search.value)
          .then((res) => res.data)
          .catch((error) => error);
      }

      loading.value = false;
      if (iscode(result)) {
        total.value = result.meta.total;
        list.value = result.data;
      }
    };
    const typeList=ref([])
    const getTypeList=async ()=>{
      let result=await getTemplatesTypeList().then(res=>res.data).catch(error=>error)
      typeList.value=result.data
    }
    const getTemplateTypeName = (record) => {
      if (record.type_name || record.affiliation_text) {
        return record.type_name || record.affiliation_text;
      }
      const type = typeList.value.find((item) => String(item.type_id) === String(record.type));
      if (type) {
        return type.type_name;
      }
      const defaultTypes = {
        1: "普通模板",
        2: "云店模板",
        3: "溯源模板",
        4: "大转盘模板",
      };
      return defaultTypes[record.type] || "-";
    };
    const is_open_sy = ref(0)
    //获取配置
    const getConfig = async () => {
      let result = await getAdvertisement().then((res) => res.data).catch((error) => error);
      if (iscode(result)) {
        is_open_sy.value = result.data.is_open_sy;
      }
    };
    //修改配置
    const setConfig = async (e) => {
      console.log(e)
      let result = await updateAdvertisement({is_open_sy:e}).then((res) => res.data).catch((error) => error);
      iscode(result, true);
    };
    const callback = (e) => {
      search.value.page = 1;
      initData();
    };
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    initData();
    // 添加模板
    const templateVisible = ref(false);
    const createTemplate = () => {
      templateVisible.value = true;
      // $router.push({path:''})
    };
    // 删除模板
    const del = (id) => {
      Modal.confirm({
        centered: true,
        content: "删除后将无法恢复，您确定要删除吗？",
        onOk: async () => {
          let res = await delTemplates(id).then((res) => res.data);
          if (iscode(res, true)) {
            search.value.page = 1;
            initData(search.value);
          }
        },
      });
    };
    const defaultSet = (id) => {
      Modal.confirm({
        centered: true,
        content: "您确定要将该模板设置为默认模板吗？",
        onOk: async () => {
          let res = await setDefault(id).then((res) => res.data);
          if (iscode(res, true)) {
            search.value.page = 1;
            initData(search.value);
          }
        },
      });
    };
    const is_customized =ref(false)
    onMounted(async()=>{
      getConfig();
      getTypeList();
      let result=await is_have_customized().then(res=>res.data).catch(error=>error)
      is_customized.value=result.data.is_have
    })
    return {
      changTime,
      search,
      list,
      total,
      pageCurrentChange,
      pageSearchChange,
      createTemplate,
      templateVisible,
      oss,
      del,
      loading,
      activeKey,
      callback,
      defaultSet,
      is_customized,
      typeList,
      myTemplateColumns,
      getTemplateTypeName,
      is_open_sy,
      setConfig
    };
  },
};
</script>
<style lang="less" scoped>
img {
  max-width: 100%;
  // max-height: 100%;
  display: block;
  margin: 0 auto;
}
.label {
  color: #999;
}
.actions {
  display: flex;
  justify-content: flex-end;
}
.panel {
  display: flex;
  align-items: center;
  padding: 40px;
  > li {
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 30px;
    text-align: center;
    font-size: 20px;
    color: #333;
    border-radius: 20px;
    position: relative;
    cursor: pointer;
    &:hover {
      box-shadow: 9px 11px 20px rgba(0, 0, 0, 0.3);
      transition: all 0.6s;
      transform: translateY(-10px);
    }
    img {
      width: 50%;
      margin-bottom: 20px;
    }
  }
}
.tempalteImg {
  overflow: hidden;
  position: relative;
  background-image: url('../../../assets/images/huawei.png');
  background-size: cover;
  background-repeat: no-repeat;
  padding: 0px 5px 0 4px;
  padding-top: 4px!important;
  overflow: hidden;
  &:hover .mask{
   transform: translate(-50%,0)
  }
  .bar{
    position: absolute;
    width: 75px;
    right: 15px;
    top: 30px;
    height: auto;
    border-radius: 0;
  }
  img{
    width: 100%;
    height: 100%;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
  .miniApp{
    position: absolute;
    ::before{
      content: '';
      position: absolute;
      width: 40px;
      background-color: rgba(0,0,0,.3);
      border-radius: 10px;
      height: 20px;
      right: 0;
    }
  }
  .mask{
    position: absolute;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.4);
    width: 95%;
    left: 50%;
    color: #fff;
    padding: 10px 6px;
    transition: all 0.3s;
    transform: translate(-50%, 108px);
  }
  // .templateTags{
  //   position: relative;
  //   right: -30%;
  //   top: 20px;
  //   z-index: 10;
  //   font-weight: 600;
  //   width: 100%;
  //   text-align: center;
  //   height: 40px;
  //   background-color: #3185dd;
  //   line-height: 40px;
  //   color: #fff;
  //   transform: rotate(45deg);
  // }
}
.newTemplateImg{
    overflow: hidden;
  position: relative;
  background-image:none;
  // background-image: url('../../../assets/images/huawei.png');
  background-size: cover;
  background-repeat: no-repeat;
  padding: 0;
  overflow: hidden;
  &:hover .mask{
   transform: translate(-50%,0)
  }
  .bar{
    position: absolute;
    width: 75px;
    right: 15px;
    top: 30px;
    height: auto;
    border-radius: 0;
  }
  img{
    width: 100%;
    // height: 100%;
    height:auto;
    max-height: none;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
  .miniApp{
    position: absolute;
    ::before{
      content: '';
      position: absolute;
      width: 40px;
      background-color: rgba(0,0,0,.3);
      border-radius: 10px;
      height: 20px;
      right: 0;
    }
  }
  .mask{
    position: absolute;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.4);
    width: 95%;
    left: 50%;
    color: #fff;
    padding: 10px 6px;
    transition: all 0.3s;
    transform: translate(-50%, 108px);
  }
}


</style>
